export default {
   request_url: 'https://jxjyxyapi.zjiet.edu.cn/api/',
    // request_url: 'http://officaialwebsite.com/api/'
}
